import { Icon } from '@iconify/react'
import { Typography } from '@mui/material'
import { Box } from '@mui/material'
import CustomAvatar from 'src/@core/components/mui/avatar'
import { menuList } from 'src/data/general/menu'

const CustomHeader = props => {
  const { title, icon } = props
  const getIcon = menuList?.find(i => i.text === icon)

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignItems: 'center',
          paddingTop: '0.5em',
          paddingBottom: '0.5em'
        }}
      >
        {getIcon?.icon && (
          <CustomAvatar skin='light' variant='rounded' color='info' sx={{ mr: 3, height: 34, width: 34 }}>
            <Icon icon={getIcon?.icon} />
          </CustomAvatar>
        )}
        {/*
          component='h1': este es el titulo de la herramienta, o sea el
          encabezado principal de la pagina. Como Typography deriva la etiqueta
          del variant, salia como <h5> y la pagina no tenia h1 — mal para el
          orden de encabezados y para como Google lee el documento. El tamano
          visual no cambia: eso lo sigue decidiendo variant.
        */}
        <Typography align='center' variant='h5' component='h1' color='primary'>
          {title?.toUpperCase()}
        </Typography>
      </Box>
    </>
  )
}

export default CustomHeader
